
  import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
/* Apply component specific CSS */
:host{
  padding:0px !important;
  display:block;
}

.alert-banner {
  position:relative;
  box-sizing:border-box;
  width:100%;
  border-radius:0.75rem;
  border-width:1px;
  border-style:solid;
  padding:1rem;
}

.alert-banner-inner {
  display:flex;
}

@media (min-width: 1024px) {

  .alert-banner-inner {
    align-items:center;
  }
}

.alert-banner.information {
  border-color:var(--ui-infoText);
  background-color:var(--ui-info);
}

.alert-banner.warning {
  border-color:var(--ui-warningText);
  background-color:var(--ui-warning);
}

.alert-banner.error {
  border-color:var(--ui-errorText);
  background-color:var(--ui-error);
}

.alert-banner.success {
  border-color:var(--ui-successText);
  background-color:var(--ui-success);
}

.alert-banner.dismissed {
  display:none;
}

.alert-banner.un-dismissible .alert-banner-dismiss-icon {
  display:none;
}

.alert-banner-content-section {
  width:100%;
}

.alert-banner-heading-subsection {
  display:inline-flex;
  width:100%;
  justify-content:space-between;
}

.alert-banner-type-icon {
  margin-right:0.75rem;
}

@media (min-width: 1024px) {

  .alert-banner-type-icon {
    margin-right:1.75rem;
  }
}

.alert-banner-type-icon {
  padding-top:0.25rem;
}

@media (min-width: 1024px) {

  .alert-banner-type-icon {
    padding-top:0px;
  }
}

.alert-banner-type-icon.information {
  color:var(--ui-infoText);
}

.alert-banner-type-icon.warning {
  color:var(--ui-warningText);
}

.alert-banner-type-icon.error {
  color:var(--ui-errorText);
}

.alert-banner-type-icon.success {
  color:var(--ui-successText);
}

.alert-banner-heading {
  margin-bottom:0.375rem;
  font-family:var(--ff-display);
  font-size:var(--fs-h4-small);
  line-height:var(--lh-h4-small);
  font-weight:var(--fw-semibold);
  color:var(--neutral-black);
}

@media (min-width: 1024px) {

  .alert-banner-heading {
    margin-bottom:0.75rem;
  }

  .alert-banner-heading {
    font-size:var(--fs-3xl);
    line-height:var(--lh-3xl);
  }
}

.alert-banner-body-text {
  font-family:var(--ff-body);
  color:var(--neutral-gray-1);
}

@media (min-width: 1024px) {

  .alert-banner-body-text {
    font-size:var(--fs-lg);
    line-height:var(--lh-lg);
  }
}

a {
  color:var(--primary-blue-light-2);
  text-decoration-line:underline;
}

a:hover {
  color:var(--primary-blue);
}

.alert-banner-dismiss-icon {
  cursor:pointer;
  border-radius:9999px;
  border-width:1px;
  border-style:solid;
  background-color:var(--neutral-white);
  position:absolute;
  display:flex;
  align-items:center;
  justify-content:center;

  right:-20px;
  top:-20px;
  height:40px;
  width:40px;
  min-height:40px;
  min-width:40px;
}

[cloned-slot-name='alert-banner-dismiss-button'] button {
  display:flex;
  border-width:0px;
  background-color:var(--neutral-transparent);
  padding:0px;
}

.alert-banner-dismiss-icon.information {
  border-color:var(--ui-infoText);
}

.alert-banner-dismiss-icon.warning {
  border-color:var(--ui-warningText);
}

.alert-banner-dismiss-icon.error {
  border-color:var(--ui-errorText);
}

.alert-banner-dismiss-icon.success {
  border-color:var(--ui-successText);
}

:host([site='GHS']) [cloned-slot-name='alert-banner-body-text'] {
  margin-top:-1rem;
  margin-bottom:-1rem;
}

:host([site='BH']) .alert-banner {
  border-radius:0px;
}

:host([site='BH']) .alert-banner {
  border-top-width:4px;
}

:host([site='BH']) .alert-banner {
  background-color:var(--bh-neutral-white);
}

:host([site='BH']) .alert-banner {
  padding-top:0.5rem;
  padding-bottom:0.5rem;
}

:host([site='BH']) .alert-banner {
  padding-left:0.75rem;
  padding-right:0.75rem;
}

@media (min-width: 1024px) {

  :host([site='BH']) .alert-banner {
    padding-top:0.75rem;
    padding-bottom:0.75rem;
  }
}

@media (min-width: 1024px) {

  :host([site='BH']) .alert-banner {
    padding-left:1.75rem;
    padding-right:1.75rem;
  }
}

:host([site='BH']) .alert-banner-body-text, :host([site='BH']) .alert-banner-heading {
  font-family:var(--bh-ff-body);
}

:host([site='BH']) .alert-banner-heading {
  margin-bottom:0.25rem;
}

:host([site='BH']) .alert-banner-heading {
  font-size:var(--bh-fs-heading-03);
  line-height:var(--bh-lh-heading-03);
  letter-spacing:var(--bh-ls-heading-03);
}

:host([site='BH']) .alert-banner-body-text {
  font-size:var(--bh-fs-body-02);
  line-height:var(--bh-lh-body-02);
  letter-spacing:var(--bh-ls-body-02);
}

:host([site='BH']) .alert-banner-body-text p {
  margin-top:0px;
  margin-bottom:0px;
}

:host([site='BH']) .alert-banner-dismiss-icon {
  position:static;
}

:host([site='BH']) .alert-banner-dismiss-icon {
  margin-top:auto;
  margin-bottom:auto;
}

:host([site='BH']) .alert-banner-dismiss-icon {
  height:0.75rem;
}

:host([site='BH']) .alert-banner-dismiss-icon {
  min-height:0px;
}

:host([site='BH']) .alert-banner-dismiss-icon {
  width:0.75rem;
}

:host([site='BH']) .alert-banner-dismiss-icon {
  min-width:0px;
}

:host([site='BH']) .alert-banner-dismiss-icon {
  border-style:none;
}

:host([site='BH']) .alert-banner-content-section {
  margin-right:auto;
}

:host([site='BH']) .alert-banner-content-section {
  padding-left:0.75rem;
  padding-right:0.75rem;
}

@media (min-width: 1024px) {

  :host([site='BH']) .alert-banner-content-section {
    padding-left:1.5rem;
    padding-right:1.5rem;
  }
}

:host([site='BH']) outline-container {
  display:flex;
}

:host([site='BH']) outline-container {
  flex-direction:row;
}

:host([site='BH']) outline-container {
  justify-content:space-between;
}

:host([site='BH']) .alert-banner-type-icon {
  margin-top:auto;
  margin-bottom:auto;
}

:host([site='BH']) .alert-banner-type-icon {
  margin-left:0px;
  margin-right:0px;
}

:host([site='BH']) .alert-banner-type-icon {
  padding:0px;
}

:host([site='BH']) .alert-banner.information {
  border-color:var(--bh-status-info);
}

:host([site='BH']) .alert-banner.warning {
  border-color:var(--bh-status-warning);
}

:host([site='BH']) .alert-banner.error {
  border-color:var(--bh-status-danger);
}

:host([site='BH']) .alert-banner.success {
  border-color:var(--bh-status-success);
}
`;